<template>    <section class="main app-theme full-width-layout">
    <div class="perfil-wrapper">

      <!-- LOADING -->
      <div v-if="isLoading" class="perfil-loading">
        <b-spinner variant="primary" style="width:3rem;height:3rem;" />
        <p class="mt-3 mb-0 font-weight-bold text-muted">Carregando informações...</p>
      </div>

      <template v-else>

        <!-- HERO -->
        <div class="hero-card mb-4">
          <div class="hero-avatar">
            {{ (usuario.dadosCadastraisAssociado[0].nomecomercial || 'E').charAt(0).toUpperCase() }}
          </div>
          <div class="hero-info">
            <h2 class="hero-name">{{ usuario.dadosCadastraisAssociado[0].nomecomercial || 'Empresa' }}</h2>
            <div class="d-flex flex-wrap mt-1">
              <span class="meta-badge mr-2">
                <i class="fa fa-id-card mr-1"></i>{{ docFormatado || '—' }}
              </span>
              <span v-if="usuario.dadosCadastraisAssociado[0].inscest" class="meta-badge meta-badge--light">
                IE: {{ usuario.dadosCadastraisAssociado[0].inscest }}
              </span>
            </div>
          </div>
        </div>

        <!-- TABS -->
        <b-tabs v-model="abaAtiva" pills content-class="pt-4" no-fade lazy @activate-tab="onActivateTab">

          <!-- ── ABA 1: EMPRESA ── -->
          <b-tab>
            <template #title><i class="fa fa-building mr-2"></i>Empresa</template>

            <div class="panel">
              <div class="panel__header">
                <span class="panel__title">Dados Cadastrais</span>
              </div>
              <b-row class="mt-3">
                <b-col md="6" class="mb-4">
                  <label class="lbl">CNPJ / CPF</label>
                  <b-form-input :value="docFormatado" disabled class="inp inp--ro" />
                </b-col>
                <b-col md="6" class="mb-4">
                  <label class="lbl">Inscrição Estadual</label>
                  <b-form-input :value="usuario.dadosCadastraisAssociado[0].inscest" disabled class="inp inp--ro" />
                </b-col>
                <b-col cols="12">
                  <label class="lbl">Nome Comercial</label>
                  <b-form-input
                    id="nomeComercial"
                    v-model.trim="usuario.dadosCadastraisAssociado[0].nomecomercial"
                    @input="onNomeComercialInput"
                    class="inp"
                  />
                  <div v-if="nomeComercialMudou && !modalUpload.confirmed" class="text-right mt-2">
                    <b-button variant="outline-secondary" size="sm" @click="reverterNomeComercial">
                      <i class="fa fa-undo mr-1"></i>Desfazer
                    </b-button>
                  </div>
                </b-col>
              </b-row>

              <transition name="slide-fade">
                <div v-if="nomeComercialMudou" class="upload-box mt-4">
                  <div class="upload-box__head">
                    <i class="fa fa-exclamation-triangle text-warning mt-1 mr-2"></i>
                    <div>
                      <strong class="text-dark">Documentação obrigatória</strong>
                      <p class="mb-0 small text-muted mt-1">Para alterar o nome comercial, anexe o Contrato Social, o documento de identidade do Responsável Legal e o Termo de Responsabilidade.</p>
                    </div>
                  </div>

                  <div class="mt-3">
                    <label class="small font-weight-bold text-uppercase mb-1">Contrato Social <span class="text-danger">*</span></label>
                    <b-form-file
                      :key="modalUpload.keyContrato"
                      v-model="modalUpload.fileContratoSocial"
                      size="sm"
                      placeholder="Selecione o Contrato Social..."
                      accept=".pdf,.jpg,.jpeg,.png"
                      browse-text="Procurar"
                    />
                    <div class="d-flex align-items-center mt-1" v-if="modalUpload.fileContratoSocial">
                      <small class="text-success mr-auto"><i class="fa fa-check mr-1"></i>{{ modalUpload.fileContratoSocial.name }}</small>
                      <button type="button" class="doc-rm-btn" @click="removerArquivo('contratoSocial')" title="Remover">&times;</button>
                    </div>
                  </div>

                  <div class="mt-3">
                    <label class="small font-weight-bold text-uppercase mb-1">Responsável Legal <span class="text-danger">*</span></label>
                    <b-form-file
                      :key="modalUpload.keyResponsavel"
                      v-model="modalUpload.fileResponsavelLegal"
                      size="sm"
                      placeholder="Selecione o documento do Responsável Legal..."
                      accept=".pdf,.jpg,.jpeg,.png"
                      browse-text="Procurar"
                    />
                    <div class="d-flex align-items-center mt-1" v-if="modalUpload.fileResponsavelLegal">
                      <small class="text-success mr-auto"><i class="fa fa-check mr-1"></i>{{ modalUpload.fileResponsavelLegal.name }}</small>
                      <button type="button" class="doc-rm-btn" @click="removerArquivo('responsavelLegal')" title="Remover">&times;</button>
                    </div>
                  </div>

                  <div class="mt-3">
                    <div class="d-flex align-items-center mb-1">
                      <label class="small font-weight-bold text-uppercase mb-0">Termo de Responsabilidade <span class="text-danger">*</span></label>
                      <a href="#" class="small ml-2" @click.prevent="baixarTermoNomeComercial" title="Baixar modelo em PDF">
                        <i class="fa fa-download mr-1"></i>Baixar modelo
                      </a>
                    </div>
                    <b-form-file
                      :key="modalUpload.keyTermo"
                      v-model="modalUpload.fileTermoResponsabilidade"
                      size="sm"
                      placeholder="Selecione o Termo de Responsabilidade..."
                      accept=".pdf,.jpg,.jpeg,.png"
                      browse-text="Procurar"
                    />
                    <div class="d-flex align-items-center mt-1" v-if="modalUpload.fileTermoResponsabilidade">
                      <small class="text-success mr-auto"><i class="fa fa-check mr-1"></i>{{ modalUpload.fileTermoResponsabilidade.name }}</small>
                      <button type="button" class="doc-rm-btn" @click="removerArquivo('termoResponsabilidade')" title="Remover">&times;</button>
                    </div>
                  </div>

                  <div class="d-flex mt-3" v-if="modalUpload.fileContratoSocial && modalUpload.fileResponsavelLegal && modalUpload.fileTermoResponsabilidade">
                    <b-button variant="success" size="sm" class="ml-auto font-weight-bold px-3" @click="confirmarSalvarEmpresa(usuario.dadosCadastraisAssociado[0])" :disabled="empresaSalvando">
                      <b-spinner small v-if="empresaSalvando" class="mr-1" />
                      <i class="fa fa-check mr-1" v-else></i>
                      {{ empresaSalvando ? 'Enviando...' : 'Salvar e Enviar' }}
                    </b-button>
                  </div>
                </div>
              </transition>
            </div>

            <transition name="slide-fade">
              <div v-if="sucessoEnvio" class="panel panel--success mt-4">
                <div class="panel__header d-flex align-items-center">
                  <i class="fa fa-check-circle mr-2"></i>
                  <span class="panel__title">{{ sucessoEnvio.titulo }}</span>
                </div>
                <p class="mb-0 mt-2 small text-dark">{{ sucessoEnvio.mensagem }}</p>
              </div>
            </transition>

            <div class="panel mt-4" v-if="todosChamadosAbertos.length > 0 || loadingChamados || erroChamados">
              <div class="panel__header d-flex align-items-center">
                <span class="panel__title">Solicitações em Andamento</span>
                <b-spinner small v-if="loadingChamados" class="ml-2" />
              </div>
              <b-alert v-if="erroChamados" show variant="warning" class="mt-3 mb-0 small">{{ erroChamados }}</b-alert>
              <div v-else class="mt-3">
                <div v-for="item in todosChamadosAbertos" :key="item.codigo" class="req-row">
                  <div>
                    <span class="font-weight-bold text-dark">#{{ item.codigo }}</span>
                    <span class="text-muted small ml-2">{{ formatData(item.dataAbertura) }}</span>
                  </div>
                  <span class="req-tag">{{ statusLabel(item) }}</span>
                </div>
              </div>
            </div>
          </b-tab>

          <!-- ── ABA 2: CONTATOS ── -->
          <b-tab>
            <template #title><i class="fa fa-users mr-2"></i>Contatos</template>

            <div class="d-flex justify-content-between align-items-center mb-4">
              <div>
                <h6 class="font-weight-bold text-dark mb-0">Contatos Cadastrados</h6>
                <br/>
                <small class="text-muted">{{ listaContatosUnificada.length }} contato(s)</small>
              </div>
              <b-button variant="primary" size="sm" class="px-3 font-weight-bold" style="border-radius:20px;" @click="abrirModalContato">
                <i class="fa fa-plus mr-1"></i> Novo Contato
              </b-button>
            </div>

            <div v-if="listaContatosUnificada.length === 0" class="empty-state">
              <div class="empty-state__icon-wrap">
                <i class="fa fa-users"></i>
              </div>
              <p class="font-weight-bold text-dark mb-1">Nenhum contato cadastrado</p>
              <small class="text-muted d-block mb-3">Adicione um contato para manter seus dados atualizados.</small>
              <b-button variant="outline-primary" size="sm" @click="abrirModalContato">Adicionar Contato</b-button>
            </div>

            <div v-else class="accordion" role="tablist">
              <div
                v-for="(contato, index) in listaContatosUnificada"
                :key="'contato-' + index"
                class="contato-card mb-3"
              >
                <div class="contato-card__head" @click="toggleContato(index)">
                  <div class="ct-avatar" :class="contato.tipo === 'pessoal' ? 'ct-avatar--blue' : 'ct-avatar--teal'">
                    {{ (contato.dados.nome || '?').charAt(0).toUpperCase() }}
                  </div>
                  <div class="ct-info">
                    <div class="ct-name">{{ contato.dados.nome || 'Sem nome' }}</div>
                  </div>
                  <b-badge v-if="contato.dados.responsavelLegal" variant="success" class="ml-auto mr-1 align-self-center">
                    Representante Legal
                  </b-badge>
                  <b-badge :variant="contato.tipo === 'pessoal' ? 'primary' : 'info'" class="mr-3 align-self-center" :class="contato.dados.responsavelLegal ? '' : 'ml-auto'">
                    {{ contato.tipo === 'pessoal' ? 'Principal' : 'Complementar' }}
                  </b-badge>
                  <i class="fa fa-chevron-down ct-chevron align-self-center" :class="{ 'ct-chevron--open': !!contatosAbertos[index] }"></i>
                </div>
                <b-collapse :visible="!!contatosAbertos[index]">
                  <div class="contato-card__body">
                    <contato-card
                      :required-all="contato.tipo === 'pessoal'"
                      :allow-add-email="true"
                      :enable-deactivation="contato.tipo !== 'pessoal'"
                      :show-responsavel-legal="contato.tipo === 'pessoal'"
                      :is-principal="contato.tipo === 'pessoal'"
                      :model.sync="contato.dados"
                      :other-contacts="outrosBoletos(index)"
                      @comunicacao-change="atualizarBoletos(index, $event)"
                      @dirty-change="onContatoDirtyChange(index, $event)"
                      @save="salvarContatoDireto($event)"
                      @deactivate="inativarContato(contato.dados.ID)"
                      @definir-responsavel-legal="definirResponsavelLegal(contato.dados.ID)"
                    />
                  </div>
                </b-collapse>
              </div>
            </div>
          </b-tab>

          <!-- ── ABA 3: ENDEREÇOS ── -->
          <b-tab>
            <template #title><i class="fa fa-map-marker-alt mr-2"></i>Endereços</template>

            <b-row>
              <b-col lg="6" class="mb-4 mb-lg-0">
                <div class="panel h-100 d-flex flex-column">
                  <div class="panel__header">
                    <span class="panel__title">
                      <i class="fa fa-building mr-2 text-primary"></i>Endereço Correspondência
                    </span>
                  </div>
                  <div class="mt-3 flex-grow-1">
                    <endereco-form
                      ref="endEmp"
                      titulo=""
                      :model.sync="endereco.empresa"
                      :locked="false"
                      :required-all="true"
                      @cep="(val) => __resolverCep('empresa', val)"
                    />
                  </div>
                  <div class="pt-3 mt-2 border-top text-right">
                    <b-button variant="primary" class="px-4" @click="salvarEnderecoDireto('empresa')" :disabled="endereco.loadingEmpresa || !enderecoEmpresaSalvavel">
                      <b-spinner small v-if="endereco.loadingEmpresa" class="mr-1" />
                      <i class="fa fa-save mr-1" v-else></i>
                      {{ endereco.loadingEmpresa ? 'Salvando...' : 'Salvar Endereço' }}
                    </b-button>
                  </div>
                </div>
              </b-col>
              <b-col lg="6">
                <div class="panel h-100 d-flex flex-column">
                  <div class="panel__header">
                    <span class="panel__title">
                      <i class="fa fa-file-invoice-dollar mr-2 text-warning"></i>Endereço Cobrança
                    </span>
                  </div>
                  <div class="mt-3 flex-grow-1">
                    <endereco-form
                      ref="endCob"
                      titulo=""
                      :model.sync="endereco.cobranca"
                      :locked="false"
                      :required-all="true"
                      @cep="(val) => __resolverCep('cobranca', val)"
                    />
                  </div>
                  <div class="pt-3 mt-2 border-top d-flex justify-content-end align-items-center">
                    <b-button variant="primary" class="px-4" @click="salvarEnderecoDireto('cobranca')" :disabled="endereco.loadingCobranca || !enderecoCobrancaSalvavel">
                      <b-spinner small v-if="endereco.loadingCobranca" class="mr-1" />
                      <i class="fa fa-save mr-1" v-else></i>
                      {{ endereco.loadingCobranca ? 'Salvando...' : 'Salvar Endereço' }}
                    </b-button>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-tab>

        </b-tabs>
      </template>

      <!-- MODAL ALTERAÇÕES NÃO SALVAS -->
      <b-modal
        v-model="mostrarModalSaida"
        title="Alterações não salvas"
        hide-footer
        centered
        no-enforce-focus
      >
        <p class="mb-4">Você tem alterações não salvas nesta aba. Se sair, as alterações serão perdidas.</p>
        <div class="d-flex justify-content-end" style="gap: 8px">
          <b-button variant="outline-secondary" @click="cancelarTrocaAba">Cancelar</b-button>
          <b-button variant="danger" @click="confirmarTrocaAba">Descartar e sair</b-button>
        </div>
      </b-modal>

      <!-- MODAL PREVIEW -->
      <b-modal ref="modalPreview" size="xl" title="Pré-visualização" hide-footer @hidden="clearPreview">
        <template v-if="previewUrl && previewFile && isImg(previewFile)">
          <img :src="previewUrl" class="img-fluid d-block mx-auto" />
        </template>
        <template v-else-if="previewUrl && previewFile && isPdf(previewFile)">
          <iframe :src="previewUrl" style="width:100%;height:75vh;border:0" />
        </template>
        <div v-else class="text-muted text-center p-3">Pré-visualização não suportada.</div>
      </b-modal>

      <!-- MODAL NOVO CONTATO -->
      <b-modal id="modalContato" ref="modalContato" hide-footer size="lg" title-class="d-none" body-class="p-0">

          <!-- ETAPA 2: formulário -->
        <template v-if="formContatoEtapa === 2">
          <div class="p-4 border-bottom bg-light">
            <div class="d-flex justify-content-between align-items-center">
              <h5 class="font-weight-bold m-0">
                <i class="fa fa-user-plus mr-2 text-primary"></i>Novo Contato
              </h5>
              <div class="d-flex align-items-center" style="gap:8px">
                <span class="tipo-badge" :class="formContato.tipoVinculo === 'pessoal' ? 'tipo-badge--blue' : 'tipo-badge--green'">
                  <i :class="formContato.tipoVinculo === 'pessoal' ? 'fa fa-briefcase' : 'fa fa-user-plus'" class="mr-1"></i>
                  {{ formContato.tipoVinculo === 'pessoal' ? 'Sócio Administrador' : 'Contato Complementar' }}
                </span>
              </div>
            </div>
          </div>

          <div class="p-4">
            <div class="mbox mb-4">
              <p class="mbox__title"><i class="fa fa-user-circle mr-2"></i>Dados Pessoais</p>
              <b-row class="mt-3">
                <b-col cols="12" class="mb-3">
                  <label class="lbl">Nome Completo</label>
                  <b-form-input v-model="formContato.nome" class="inp" placeholder="Digite o nome completo..." :state="textoState(formContato.nome)" />
                  <b-form-invalid-feedback :state="textoState(formContato.nome)">Informe o nome do contato.</b-form-invalid-feedback>
                </b-col>
                <b-col md="6">
                  <label class="lbl">CPF</label>
                  <b-form-input
                    v-model="formContato.cpf"
                    v-mask="['###.###.###-##']"
                    inputmode="numeric"
                    class="inp"
                    :class="{ 'inp--obrig-invalido': cpfState(formContato.cpf) === false }"
                    placeholder="000.000.000-00"
                    :state="cpfState(formContato.cpf)"
                  />
                  <b-form-invalid-feedback :state="cpfState(formContato.cpf)">
                    {{ !formContato.cpf ? 'CPF é obrigatório.' : 'CPF inválido.' }}
                  </b-form-invalid-feedback>
                </b-col>
              </b-row>
            </div>

            <div class="mbox mb-4">
              <p class="mbox__title"><i class="fa fa-sliders-h mr-2"></i>Preferências</p>
              <b-row class="mt-3">
                <b-col md="6" class="mb-3 mb-md-0">
                  <label class="lbl">Canal Preferencial</label>
                  <b-form-select v-model="formContato.preferencia" :options="opcoesPreferencia" class="inp" />
                </b-col>
                <b-col md="6">
                  <label class="lbl">Receber Comunicados</label>
                  <b-form-checkbox-group v-model="formContato.tipoComunicacao" :options="opcoesComunicacao" class="mt-2" />
                </b-col>
              </b-row>
            </div>

            <div class="mbox mb-4">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <p class="mbox__title mb-0"><i class="fa fa-envelope mr-2"></i>E-mails</p>
                <b-button variant="primary" size="sm" @click="addEmailLinha">
                  <i class="fa fa-plus mr-1"></i> Adicionar
                </b-button>
              </div>
              <div v-for="(email, i) in formContato.emails" :key="'em-' + i" class="d-flex align-items-center mb-2" style="gap:8px">
                <b-form-input
                  v-model.trim="email.valor"
                  type="email"
                  inputmode="email"
                  class="inp flex-grow-1"
                  placeholder="email@dominio.com"
                  :state="email.valor ? emailState(email.valor) : null"
                />
                <b-form-select v-model="email.relacao" :options="opcoesRelacaoEmail" class="inp flex-shrink-0" style="width:195px" />
                <button type="button" class="rm-btn flex-shrink-0" title="Remover" @click="removeEmailLinha(i)">&times;</button>
              </div>
              <p v-if="!formContato.emails.length" class="text-muted small text-center mt-2 mb-0">Nenhum e-mail adicionado.</p>
            </div>

            <div class="mbox">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <p class="mbox__title mb-0"><i class="fa fa-phone mr-2"></i>Telefones</p>
                <b-button variant="success" size="sm" @click="addTelefoneLinha" :disabled="formContato.telefones.length >= 2">
                  <i class="fa fa-plus mr-1"></i> Adicionar
                </b-button>
              </div>
              <div v-for="(tel, i) in formContato.telefones" :key="'tel-' + i" class="d-flex align-items-center mb-2" style="gap:8px">
                <b-form-select v-model="tel.tipoClassificacao" :options="opcoesClassificacaoTelefone" class="inp flex-shrink-0" style="width:210px" />
                <b-form-input
                  v-model="tel.numero"
                  :formatter="formatarApenasNumeros"
                  inputmode="numeric"
                  class="inp flex-grow-1"
                  placeholder="Apenas números"
                  :state="tel.numero ? telefoneState(tel.numero) : null"
                />
                <button type="button" class="rm-btn flex-shrink-0" title="Remover" @click="removeTelefoneLinha(i)">&times;</button>
              </div>
              <p v-if="!formContato.telefones.length" class="text-muted small text-center mt-2 mb-0">Nenhum telefone adicionado.</p>
            </div>
          </div>

          <div class="p-3 border-top d-flex justify-content-end bg-light">
            <b-button variant="secondary" class="mr-2" @click="$refs.modalContato.hide()">Cancelar</b-button>
            <b-button variant="success" class="px-5 font-weight-bold" :disabled="!novoContatoValido || salvandoNovoContato" @click="salvarNovoContato">
              <b-spinner v-if="salvandoNovoContato" small class="mr-2" />
              <i v-else class="fa fa-check mr-2"></i>
              {{ salvandoNovoContato ? 'Salvando...' : 'Salvar Contato' }}
            </b-button>
          </div>
        </template>
      </b-modal>

    </div>
  </section>
</template>

<script>
import EnderecoForm from "./EnderecoForm.vue";
import ContatoCard from "./ContatoCard.vue";
import { jsPDF } from "jspdf";
import { clearStr, validateCPF, validateEmail } from "../../helpers";

export default {
  name: "DadosCadastrais",
  components: {
    "endereco-form": EnderecoForm,
    "contato-card": ContatoCard,
  },
  data() {
    return {
      isLoading: true,
      abaAtiva: 0,
      empresaSalvando: false,
      loadingChamados: false,
      erroChamados: "",
      todosChamadosAbertos: [],
      contatosAbertos: {},
      modalUpload: { fileContratoSocial: null, fileResponsavelLegal: null, fileTermoResponsabilidade: null, uploading: false, confirmed: false, keyContrato: 0, keyResponsavel: 0, keyTermo: 0 },
      sucessoEnvio: null,
      previewUrl: null,
      previewFile: null,

      usuario: {
        dadosCadastraisAssociado: [{}],
        dadosContatoPrincipal: [],
        dadosContatoComplementar: [],
        dadosEnderecoCobranca: [{}],
      },

      formContatoEtapa: 1,
      salvandoNovoContato: false,
      boletosPorContato: {},
      nomeComercialOriginalSnap: "",
      enderecoSnap: { empresa: null, cobranca: null },
      abaPendente: null,
      mostrarModalSaida: false,
      pendingNavigationNext: null,
      contatosDirtyMap: {},
      cepOriginalBanco: { empresa: "", cobranca: "" },

      formContato: {
        ID: null,
        CodCfo: null,
        tipoVinculo: 'complementar',
        nome: "",
        cpf: "",
        preferencia: "E",
        tipoComunicacao: [],
        emails: [{ valor: "", relacao: "EC" }],
        telefones: [{ numero: "", tipoClassificacao: 'C' }],
      },

      endereco: {
        empresa: { cep: "", logradouro: "", numero: "", complemento: "", bairro: "", cidade: "", uf: "" },
        cobranca: { cep: "", logradouro: "", numero: "", complemento: "", bairro: "", cidade: "", uf: "" },
        flags: { empLiberado: true, cobLiberado: true },
        loadingEmpresa: false,
        loadingCobranca: false
      },

      opcoesTipoVinculo: [{ value: 'pessoal', text: 'Sócio Administrador' }, { value: 'complementar', text: 'Contato Complementar' }],
      opcoesPreferencia: [
        { value: 'E', text: 'E-mail' },
        { value: 'W', text: 'WhatsApp' },
        { value: 'L', text: 'Ligação Telefônica' },
        { value: 'V', text: 'Visita Presencial' }
      ],
      opcoesRelacaoEmail: [{ value: 'EC', text: 'E-mail Corporativo' }, { value: 'EP', text: 'E-mail Pessoal' }],
      opcoesComunicacao: [{ value: 'B', text: 'Boletos' }, { value: 'C', text: 'Comunicados e soluções' }],
      opcoesClassificacaoTelefone: [
        { value: 'P', text: 'Telefone Pessoal' },
        { value: 'C', text: 'Telefone Corporativo' }
      ]
    };
  },
  computed: {
    docFormatado() {
      return this.usuario?.dadosCadastraisAssociado?.[0]?.DOC || this.usuario?.dadosCadastraisAssociado?.[0]?.doc || "";
    },
    listaContatosUnificada() {
      const lista = [];
      if (this.usuario.dadosContatoPrincipal && Array.isArray(this.usuario.dadosContatoPrincipal)) {
        this.usuario.dadosContatoPrincipal.forEach(c => lista.push({ tipo: 'pessoal', dados: c }));
      }
      if (this.usuario.dadosContatoComplementar && Array.isArray(this.usuario.dadosContatoComplementar)) {
        this.usuario.dadosContatoComplementar.forEach(c => lista.push({ tipo: 'complementar', dados: c }));
      }
      return lista;
    },
    nomeComercialMudou() {
      const atual = this.usuario?.dadosCadastraisAssociado?.[0]?.nomecomercial || "";
      return atual.replace(/\s+/g, " ").trim() !== this.nomeComercialOriginalSnap;
    },
    enderecoEmpresaSalvavel() {
      const e = this.endereco.empresa;
      const cepOk = !!(e.cep && String(e.cep).replace(/\D/g, '').length === 8);
      const preenchido = !!(cepOk && e.logradouro && e.numero && e.bairro && e.cidade && e.uf);
      const modificado = this.enderecoSnap.empresa
        ? JSON.stringify(e) !== JSON.stringify(this.enderecoSnap.empresa)
        : false;
      return preenchido && modificado;
    },
    enderecoCobrancaSalvavel() {
      const e = this.endereco.cobranca;
      const cepOk = !!(e.cep && String(e.cep).replace(/\D/g, '').length === 8);
      const preenchido = !!(cepOk && e.logradouro && e.numero && e.bairro && e.cidade && e.uf);
      const modificado = this.enderecoSnap.cobranca
        ? JSON.stringify(e) !== JSON.stringify(this.enderecoSnap.cobranca)
        : false;
      return preenchido && modificado;
    },
    novoContatoValido() {
      if (!this.textoState(this.formContato.nome)) return false;
      if (!this.formContato.cpf || !this.cpfState(this.formContato.cpf)) return false;
      const emails = this.formContato.emails || [];
      if (!emails.length || emails.some(e => !e.valor || !this.emailState(e.valor))) return false;
      const tels = this.formContato.telefones || [];
      if (!tels.length || tels.some(t => !t.numero || !this.telefoneState(t.numero))) return false;
      return true;
    },
    abaTemAlteracoes() {
      if (this.abaAtiva === 0) {
        return this.nomeComercialMudou || !!(this.modalUpload.fileContratoSocial || this.modalUpload.fileResponsavelLegal || this.modalUpload.fileTermoResponsabilidade);
      }
      if (this.abaAtiva === 1) {
        return Object.values(this.contatosDirtyMap).some(Boolean);
      }
      if (this.abaAtiva === 2 && this.enderecoSnap.empresa) {
        const empChanged = JSON.stringify(this.endereco.empresa) !== JSON.stringify(this.enderecoSnap.empresa);
        const cobChanged = JSON.stringify(this.endereco.cobranca) !== JSON.stringify(this.enderecoSnap.cobranca);
        return empChanged || cobChanged;
      }
      return false;
    },
    storeUserDetails() { return this.$store.state.userDetails; },
    formatData() { return (d) => d; },
    statusLabel() { return (i) => i.status; }
  },
  watch: {
    storeUserDetails: {
      handler(val) {
        if (val && val.dadosCadastraisAssociado && typeof this.bootstrapDados === 'function') {
          this.bootstrapDados();
        }
      },
      deep: true
    },
    listaContatosUnificada: {
      immediate: true,
      handler(lista) {
        this.$nextTick(() => {
          const novo = {};
          lista.forEach((c, i) => {
            novo[i] = Array.isArray(c.dados.tipoComunicacao)
              ? [...c.dados.tipoComunicacao]
              : [];
          });
          this.boletosPorContato = novo;
        });
      }
    }
  },
  async created() {
    await this.fetchInitialData();
  },
  beforeRouteLeave(to, from, next) {
    if (this.abaTemAlteracoes) {
      this.pendingNavigationNext = next;
      this.mostrarModalSaida = true;
    } else {
      next();
    }
  },
  methods: {
    toggleContato(index) {
      this.$set(this.contatosAbertos, index, !this.contatosAbertos[index]);
    },
    onActivateTab(newIndex, _prevIndex, bvEvent) {
      if (this.abaTemAlteracoes) {
        bvEvent.preventDefault();
        this.abaPendente = newIndex;
        this.mostrarModalSaida = true;
      }
    },
    async confirmarTrocaAba() {
      this.mostrarModalSaida = false;
      if (this.pendingNavigationNext) {
        const next = this.pendingNavigationNext;
        this.pendingNavigationNext = null;
        next();
        return;
      }
      await this.fetchInitialData();
      this.$nextTick(() => {
        this.abaAtiva = this.abaPendente;
        this.abaPendente = null;
      });
    },
    cancelarTrocaAba() {
      this.mostrarModalSaida = false;
      if (this.pendingNavigationNext) {
        this.pendingNavigationNext(false);
        this.pendingNavigationNext = null;
        return;
      }
      this.abaPendente = null;
    },
    onContatoDirtyChange(index, isDirty) {
      this.$set(this.contatosDirtyMap, index, isDirty);
    },
    outrosBoletos(excluirIndex) {
      return Object.entries(this.boletosPorContato)
        .filter(([i]) => Number(i) !== excluirIndex)
        .map(([, tc]) => tc);
    },
    atualizarBoletos(index, tipoComunicacao) {
      this.$set(this.boletosPorContato, index, tipoComunicacao || []);
    },
    formatarApenasNumeros(value) { return String(value || '').replace(/\D/g, ''); },
    emailState(value) {
      const email = String(value || '').trim();
      if (!email) return false;
      return validateEmail(email);
    },
    telefoneState(value) {
      const numero = String(value || '').trim();
      if (!numero) return false;
      return /^\d+$/.test(numero);
    },
    textoState(value) {
      const texto = String(value || '').trim();
      if (!texto) return false;
      return texto.length >= 3;
    },
    cpfState(value) {
      const cpf = clearStr(String(value || ''));
      if (!cpf) return false;
      return validateCPF(cpf);
    },
    normalizarClassificacaoTelefone(value) {
      const v = String(value || '').toUpperCase().trim();
      if (['TC', 'CC'].includes(v)) return 'C';
      if (v === 'C') return 'C';
      return 'P';
    },
    relacaoTelefoneFromClassificacao(value) {
      return this.normalizarClassificacaoTelefone(value);
    },
    tipoTelefoneFromClassificacao() {
      return 'T';
    },
    validarEmailsLista(emails) {
      return (emails || []).every((email) => !email.valor || validateEmail(String(email.valor).trim()));
    },
    validarTelefonesLista(telefones) {
      return (telefones || []).every((telefone) => !telefone.numero || /^\d+$/.test(String(telefone.numero).trim()));
    },

    async fetchInitialData() {
      this.isLoading = true;
      try {
        const response = await this.$http.get('/api/CdlBh/ObterDadosCadastrais');
        const rawStr = response.data;

        // eslint-disable-next-line no-console
        console.log('[DEBUG] typeof:', typeof rawStr, '| preview:', String(rawStr).substring(0, 300));

        // Se axios devolveu string (Content-Type não reconhecido), faz parse manual
        let raw;
        if (typeof rawStr === 'string' && rawStr.trim()) {
          try { raw = JSON.parse(rawStr); } catch (e) { raw = rawStr; }
        } else {
          raw = rawStr;
        }

        // eslint-disable-next-line no-console
        console.log('[DEBUG] raw após parse:', raw);

        // Normaliza chaves do objeto raiz para lowercase
        const normRoot = (obj) => {
          if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return obj;
          const n = {};
          Object.keys(obj).forEach(k => { n[k.toLowerCase()] = obj[k]; });
          return n;
        };

        // Normaliza chaves de cada item do array para lowercase
        const normKeys = (arr) => (arr || []).map(item => {
          const n = {};
          Object.keys(item).forEach(k => { n[k.toLowerCase()] = item[k]; });
          return n;
        });

        const data = normRoot(raw);

        // eslint-disable-next-line no-console
        console.log('[DEBUG] data após normRoot:', data);

        const empresa   = data.dadoscadastraisassociado || data.dadoscadastrais || [];
        const cobranca  = data.dadosenderecocobranca   || data.enderecocobranca || [];
        const principal = data.dadoscontatoprincipal   || data.contatoprincipal || [];
        const secundario= data.dadoscontatosecundario  || data.contatosecundario || [];

        // eslint-disable-next-line no-console
        console.log('[DEBUG] empresa[]:', empresa, '| cobranca[]:', cobranca);

        if (empresa.length > 0) {
          this.usuario.dadosCadastraisAssociado = normKeys(empresa);
          const emp = this.usuario.dadosCadastraisAssociado[0];
          this.nomeComercialOriginalSnap = (emp.nomecomercial || "").replace(/\s+/g, " ").trim();
          this.mapearEndereco("empresa", emp);
        }
        if (cobranca.length > 0) {
          this.usuario.dadosEnderecoCobranca = normKeys(cobranca);
          this.mapearEndereco("cobranca", this.usuario.dadosEnderecoCobranca[0]);
        }

        this.usuario.dadosContatoPrincipal    = this.processarContatos(principal,  'pessoal');
        this.usuario.dadosContatoComplementar = this.processarContatos(secundario, 'complementar');

        this.$nextTick(() => {
          this.enderecoSnap = {
            empresa: { ...this.endereco.empresa },
            cobranca: { ...this.endereco.cobranca },
          };
          this.contatosDirtyMap = {};
        });

      } catch (error) {
        console.error("Erro dados:", error);
        this.$toast.error("Não foi possível carregar os dados atualizados.");
      } finally {
        this.isLoading = false;
      }
    },

    mapearEndereco(tipo, dadosApi) {
      if (!dadosApi) return;
      const ler = (campo) => {
        const key = Object.keys(dadosApi).find(k => k.toUpperCase() === campo.toUpperCase());
        return key ? String(dadosApi[key] || "").trim() : "";
      };
      const tipoLog = ler("TIPOLOGRAD");
      let logradouro = ler("LOGRAD");
      if (tipoLog && logradouro && !logradouro.toUpperCase().startsWith(tipoLog.toUpperCase())) {
        logradouro = `${tipoLog} ${logradouro}`;
      } else if (!logradouro && tipoLog) {
        logradouro = tipoLog;
      }
      const cepRaw = ler("CEP");
      this.endereco[tipo] = {
        cep: cepRaw,
        logradouro: logradouro,
        numero: ler("NUMERO"),
        complemento: ler("COMPLEMENTO"),
        bairro: ler("BAIRRO"),
        cidade: ler("CIDADE"),
        uf: ler("UF")
      };
      this.cepOriginalBanco[tipo] = cepRaw.replace(/\D/g, '');
    },

    normalizarRelacao(val) {
      if (!val) return 'EC';
      const str = String(val).toUpperCase().trim();
      if (str === 'EC' || str.includes('COMER')) return 'EC';
      if (str === 'EP' || str.includes('PESSOAL')) return 'EP';
      return 'EC';
    },

    normalizarPreferencia(valor) {
      if (!valor) return 'E';
      const v = String(valor).toUpperCase().trim();
      if (v === 'E' || v.includes('MAIL')) return 'E';
      if (v === 'W' || v.includes('WHATS')) return 'W';
      if (v === 'L' || v === 'T' || v.includes('LIGAC') || v.includes('TEL')) return 'L';
      if (v === 'V' || v.includes('VISIT') || v.includes('PRESENC')) return 'V';
      return 'E';
    },

    normalizarTipoComunicacao(valor) {
      if (!valor) return [];
      if (Array.isArray(valor)) return valor;
      const lista = [];
      const v = String(valor).toUpperCase();
      if (v.includes('B')) lista.push('B');
      if (v.includes('C')) lista.push('C');
      return lista;
    },

    processarContatos(listaRaw, tipoFixo) {
      if (!listaRaw || !Array.isArray(listaRaw)) return [];
      const ler = (item, keys) => {
        const k = Object.keys(item).find(key => keys.includes(key.toUpperCase()));
        return k ? String(item[k] || "").trim() : "";
      };
      const mapa = new Map();

      listaRaw.forEach(item => {
        let idPai = ler(item, ['IDCONTATO', 'ID_CONTATO']) || ler(item, ['ID']);
        const nome = ler(item, ['NOME', 'NOMECONTATO']);
        if (!idPai && !nome) return;
        const key = idPai || nome;
        const prefRaw = ler(item, ['FORMACONTATO_PREFERENCIAL', 'PREFERENCIA']);
        const comRaw = ler(item, ['TIPO_COMUNICACAO', 'TIPOCOMUNICACAO']);

        if (!mapa.has(key)) {
          mapa.set(key, {
            ID: idPai,
            CodCfo: ler(item, ['CODCFO']),
            nome: nome,
            cpf: ler(item, ['CPF']),
            tipo: tipoFixo,
            preferencia: this.normalizarPreferencia(prefRaw),
            tipoComunicacao: this.normalizarTipoComunicacao(comRaw),
            responsavelLegal: ler(item, ['RESPONSAVEL_LEGAL']) === '1',
            emails: [],
            telefones: []
          });
        }
        const card = mapa.get(key);
        const emailVal = ler(item, ['EMAIL']);
        if (emailVal && !card.emails.some(e => e.valor === emailVal)) {
          card.emails.push({
            id: ler(item, ['ID_EMAIL']),
            idContato: idPai,
            valor: emailVal,
            relacao: this.normalizarRelacao(ler(item, ['RELACAOEMAIL', 'RELACAO_EMAIL']))
          });
        }
        // Telefone principal da ZMDFCFO_CONTATO_TELEFONE — dedup por par (numero + relacao)
        const telPrincipal      = ler(item, ['TELEFONEPRINCIPAL']).replace(/\D/g, '');
        const relacaoPrincipal  = ler(item, ['RELACAOTELPRINCIPAL']) || 'C';
        const classificacaoPrincipal = this.normalizarClassificacaoTelefone(relacaoPrincipal);
        if (telPrincipal && !card.telefones.some(t => t.numero === telPrincipal && t.tipoClassificacao === classificacaoPrincipal)) {
          card.telefones.push({ id: null, idContato: idPai, numero: telPrincipal, tipoClassificacao: classificacaoPrincipal });
        }
        // Telefone secundário da ZMDFCFO_CONTATO_TELEFONE — dedup por par (numero + relacao)
        const telSecundario     = ler(item, ['TELEFONESECUNDARIO']).replace(/\D/g, '');
        const relacaoSecundario = ler(item, ['RELACAOTELSECUNDARIO']) || 'C';
        const classificacaoSecundaria = this.normalizarClassificacaoTelefone(relacaoSecundario);
        if (telSecundario && !card.telefones.some(t => t.numero === telSecundario && t.tipoClassificacao === classificacaoSecundaria)) {
          card.telefones.push({ id: null, idContato: idPai, numero: telSecundario, tipoClassificacao: classificacaoSecundaria });
        }
        // Fallback: FCFOCONTATO.TELEFONE quando não há nenhum telefone na tabela de telefones
        const telFallback = ler(item, ['TELEFONE']).replace(/\D/g, '');
        if (telFallback && !telPrincipal && !card.telefones.some(t => t.numero === telFallback)) {
          card.telefones.push({ id: null, idContato: idPai, numero: telFallback, tipoClassificacao: 'TC' });
        }
      });
      return Array.from(mapa.values());
    },

    async __resolverCep(tipo, cep) {
      if (!cep) return;
      const cepLimpo = cep.replace(/\D/g, '');
      if (cepLimpo.length !== 8) return;
      if (this.cepOriginalBanco[tipo] === cepLimpo) return;
      try {
        const response = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);
        const data = await response.json();
        if (!data.erro) {
          this.endereco[tipo].logradouro = data.logradouro;
          this.endereco[tipo].bairro = data.bairro;
          this.endereco[tipo].cidade = data.localidade;
          this.endereco[tipo].uf = data.uf;
          this.endereco[tipo].numero = "";
          this.endereco[tipo].complemento = "";
          this.$toast.success("Endereço encontrado via CEP.");
        } else {
          this.$toast.warning("CEP não encontrado.");
        }
      } catch (error) {
        console.error(error);
      }
    },

    async salvarEnderecoDireto(tipo) {
      const dados = this.endereco[tipo];
      if (!dados.cep || !dados.logradouro || !dados.numero || !dados.bairro || !dados.cidade || !dados.uf) {
        this.$toast.warning(`Preencha todos os campos obrigatórios do endereço.`);
        return;
      }
      if (tipo === 'empresa') this.endereco.loadingEmpresa = true;
      if (tipo === 'cobranca') this.endereco.loadingCobranca = true;
      const payload = {
        Tipo: tipo,
        CepCobranca: dados.cep,
        LogradouroCobranca: dados.logradouro,
        NumeroCobranca: dados.numero,
        ComplementoCobranca: dados.complemento || "",
        BairroCobranca: dados.bairro,
        CidadeCobranca: dados.cidade,
        UfCobranca: dados.uf
      };
      try {
        await this.$http.put('/api/CdlBh/Endereco', payload);
        this.$toast.success("Endereço atualizado com sucesso.");
        await this.fetchInitialData();
      } catch (e) {
        this.$toast.error("Erro ao salvar endereço.");
      } finally {
        if (tipo === 'empresa') this.endereco.loadingEmpresa = false;
        if (tipo === 'cobranca') this.endereco.loadingCobranca = false;
      }
    },

    async confirmarSalvarEmpresa(dadosEmpresa) {
      if (this.nomeComercialMudou && (!this.modalUpload.fileContratoSocial || !this.modalUpload.fileResponsavelLegal || !this.modalUpload.fileTermoResponsabilidade)) {
        this.$toast.warning("É obrigatório anexar o Contrato Social, o documento do Responsável Legal e o Termo de Responsabilidade para alterar o Nome Comercial.");
        return;
      }
      const confirmou = await this.$bvModal.msgBoxConfirm(`Salvar alterações e enviar comprovante para análise?`, {
        title: 'Confirmação', size: 'sm', centered: true
      });
      if (!confirmou) return;

      this.empresaSalvando = true;
      const getVal = (key) => {
        if (!dadosEmpresa) return "";
        return (dadosEmpresa[key] || dadosEmpresa[key.toUpperCase()] || dadosEmpresa[key.toLowerCase()] || "").trim();
      };
      try {
        const formData = new FormData();
        if (this.modalUpload.fileContratoSocial) formData.append('fileContratoSocial', this.modalUpload.fileContratoSocial);
        if (this.modalUpload.fileResponsavelLegal) formData.append('fileResponsavelLegal', this.modalUpload.fileResponsavelLegal);
        if (this.modalUpload.fileTermoResponsabilidade) formData.append('fileTermoResponsabilidade', this.modalUpload.fileTermoResponsabilidade);
        formData.append('cnpj', this.docFormatado);
        formData.append('CodCfo', getVal('CODCFO') || this.$store.state.userDetails?.CodCfo);
        formData.append('NomecomercialAtual', this.nomeComercialOriginalSnap);
        formData.append('Nomecomercial', getVal('NOMECOMERCIAL'));
        formData.append('Inscest', getVal('INSCEST'));
        formData.append('TelefoneDadosCadastrais', getVal('TELEFONE'));

        let emailEnvio = getVal('EMAIL') || getVal('EmailDadosPrincipais') || getVal('email');
        if (!emailEnvio && this.usuario.dadosContatoPrincipal && this.usuario.dadosContatoPrincipal.length > 0) {
          const socio = this.usuario.dadosContatoPrincipal[0];
          if (socio && socio.emails && socio.emails.length > 0) emailEnvio = socio.emails[0].valor;
        }
        if (!emailEnvio) {
          this.$toast.warning("Não foi possível identificar um e-mail.");
          this.empresaSalvando = false;
          return;
        }
        formData.append('EmailDadosPrincipais', emailEnvio);
        formData.append('Razaosocial', getVal('RAZAOSOCIAL') || getVal('NOMECOMERCIAL'));
        formData.append('NomeContato', this.$store.state.userDetails?.Nome || "Solicitante Portal");

        const response = await this.$http.post(`/api/CdlBh/UploadComprovanteNomeComercial`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });

        const protocoloGerado = response.data.Protocolo || response.data.protocolo || '';

        if (protocoloGerado) {
          this.todosChamadosAbertos.unshift({
            codigo: protocoloGerado,
            dataAbertura: new Date().toISOString(),
            status: 'Enviado para Análise (Nome Comercial)'
          });
        }

        this.sucessoEnvio = {
          titulo: protocoloGerado ? `Protocolo #${protocoloGerado} aberto` : 'Documentos enviados',
          mensagem: protocoloGerado
            ? `Protocolo #${protocoloGerado} aberto com sucesso. Seus documentos estão sendo analisados. Aguarde até 2 dias úteis para retorno.`
            : 'Seus documentos foram enviados com sucesso e estão sendo analisados.'
        };
        setTimeout(() => { this.sucessoEnvio = null; }, 30000);

        this.nomeComercialOriginalSnap = getVal('NOMECOMERCIAL');
        this.modalUpload.fileContratoSocial = null;
        this.modalUpload.fileResponsavelLegal = null;
        this.modalUpload.fileTermoResponsabilidade = null;
        this.modalUpload.confirmed = true;
        this.previewUrl = null;
        this.previewFile = null;
      } catch (e) {
        console.error(e);
        this.$toast.error(e.response?.data?.Mensagem || "Erro ao processar solicitação.");
      } finally {
        this.empresaSalvando = false;
      }
    },

    onNomeComercialInput() { this.modalUpload.confirmed = false; },
    reverterNomeComercial() {
      if (this.usuario.dadosCadastraisAssociado[0]) {
        this.usuario.dadosCadastraisAssociado[0].nomecomercial = this.nomeComercialOriginalSnap;
      }
      this.modalUpload.fileContratoSocial = null;
      this.modalUpload.fileResponsavelLegal = null;
      this.modalUpload.fileTermoResponsabilidade = null;
      this.modalUpload.confirmed = false;
      this.modalUpload.keyContrato++;
      this.modalUpload.keyResponsavel++;
      this.modalUpload.keyTermo++;
    },
    baixarTermoNomeComercial() {
      const emp       = this.usuario.dadosCadastraisAssociado[0] || {};
      const razao     = (emp.razaosocial || emp.nomecomercial || '').trim();
      const cnpj      = this.docFormatado || '';
      const nomeAtual = this.nomeComercialOriginalSnap || '';
      const novoNome  = (emp.nomecomercial || '').trim();
      const codSocio  = (emp.codcfo || this.$store.state.userDetails?.CodCfo || '').replace(/^0+/, '');
      const lograd    = (emp.lograd || '').trim();
      const numero    = (emp.numero || '').trim();
      const bairro    = (emp.bairro || '').trim();
      const cidade    = (emp.cidade || '').trim();
      const uf        = (emp.uf || '').trim();
      const cep       = (emp.cep || '').trim().replace(/(\d{5})(\d{3})/, '$1-$2');

      const enderecoStr = [
        lograd, numero ? `n.º ${numero}` : '', bairro ? `Bairro ${bairro}` : '',
        cidade ? `Cidade ${cidade}` : '', uf ? `UF ${uf}` : '', cep ? `CEP ${cep}` : ''
      ].filter(Boolean).join(', ');

      const doc   = new jsPDF('p', 'mm', 'a4');
      const pageW = doc.internal.pageSize.getWidth();
      const M     = 20;
      const textW = pageW - M * 2;
      let y = 22;

      doc.setFontSize(12);
      doc.setFont('helvetica', 'bold');
      doc.text('TERMO DE RESPONSABILIDADE', pageW / 2, y, { align: 'center' }); y += 7;
      doc.text('POR COMUNICAÇÃO PRÉVIA AO CONSUMIDOR', pageW / 2, y, { align: 'center' }); y += 7;
      doc.setFont('helvetica', 'normal');
      doc.text('(pela alteração do nome fantasia da empresa)', pageW / 2, y, { align: 'center' }); y += 14;

      doc.setFontSize(10);
      const p1 = `Pelo presente Termo de responsabilidade, ${razao}, inscrita no CNPJ sob o n.º ${cnpj}, estabelecida na ${enderecoStr}, associado à Câmara de Dirigentes Lojista de Belo Horizonte – CDL/BH sob o n.º ${codSocio}, neste ato representada conforme seu estatuto/contrato social, por seu/sua representante legal Sr(a). ________________________, CPF nº ________________________, doravante denominado ASSOCIADO, vem solicitar a transferência de todos os registros efetuados por esta, com o nome fantasia ${nomeAtual} para o novo nome fantasia ${novoNome}.`;
      const l1 = doc.splitTextToSize(p1, textW);
      doc.text(l1, M, y); y += l1.length * 5 + 8;

      const p2 = `O ASSOCIADO afirma estar ciente de que tal solicitação é de sua total e irrestrita responsabilidade, declarando expressamente que já enviou comunicação a todos os seus consumidores de que o nome fantasia da empresa mudou para ${novoNome}, respeitando-se, portanto, o que dispõe o art. 43, §2º do Código de Defesa do Consumidor.`;
      const l2 = doc.splitTextToSize(p2, textW);
      doc.text(l2, M, y); y += l2.length * 5 + 18;

      doc.text('Belo Horizonte,________ de __________ de _______.', pageW / 2, y, { align: 'center' }); y += 28;

      const colW = (textW - 10) / 2;
      doc.line(M, y, M + colW, y);
      doc.line(pageW - M - colW, y, pageW - M, y); y += 5;
      doc.setFontSize(9);
      doc.text('CÂMARA DE DIRIGENTES LOJISTAS DE\nBELO HORIZONTE - CDL/BH', M + colW / 2, y, { align: 'center' });
      doc.text('ASSOCIADO', pageW - M - colW / 2, y, { align: 'center' }); y += 18;

      doc.line(M, y, M + colW, y);
      doc.line(pageW - M - colW, y, pageW - M, y); y += 5;
      doc.text('Testemunha:', M, y);
      doc.text('Testemunha:', pageW - M - colW, y); y += 5;
      doc.text('CPF:', M, y);
      doc.text('CPF:', pageW - M - colW, y); y += 18;

      doc.line(M, y, M + colW, y); y += 5;
      doc.text('Consultor CDL/BH', M + colW / 2, y, { align: 'center' }); y += 20;

      doc.setFontSize(8);
      doc.text('Câmara de Dirigentes Lojistas de Belo Horizonte - Av. João Pinheiro, 495 - Cep 30130-180 - Belo Horizonte - MG', pageW / 2, 282, { align: 'center' });
      doc.text('Fone: (31) 3249-1666 - Fax: (31) 3249-1508 - www.cdlbh.com.br', pageW / 2, 287, { align: 'center' });

      doc.save(`Termo_Alteracao_Nome_Comercial.pdf`);
    },
    removerArquivo(tipo) {
      if (tipo === 'contratoSocial') {
        this.modalUpload.fileContratoSocial = null;
        this.modalUpload.keyContrato++;
      } else if (tipo === 'responsavelLegal') {
        this.modalUpload.fileResponsavelLegal = null;
        this.modalUpload.keyResponsavel++;
      } else if (tipo === 'termoResponsabilidade') {
        this.modalUpload.fileTermoResponsabilidade = null;
        this.modalUpload.keyTermo++;
      }
    },
    clearPreview() { },
    isImg(file) { return file && file.type.startsWith("image/"); },
    isPdf(file) { return file && file.type === "application/pdf"; },

    abrirModalContato() {
      this.formContatoEtapa = 2;
      this.formContato = {
        ID: null, CodCfo: null, tipoVinculo: 'complementar', nome: "", cpf: "",
        preferencia: "E", tipoComunicacao: [],
        emails: [{ valor: "", relacao: "EC" }],
        telefones: [{ numero: "", tipoClassificacao: 'C' }]
      };
      this.$refs.modalContato.show();
    },
    selecionarTipoContato(tipo) {
      this.formContato.tipoVinculo = tipo;
      this.formContatoEtapa = 2;
    },
    addEmailLinha() { this.formContato.emails.push({ valor: "", relacao: "EC" }); },
    removeEmailLinha(index) {
      this.formContato.emails.splice(index, 1);
    },
    addTelefoneLinha() {
      if (this.formContato.telefones.length >= 2) return;
      this.formContato.telefones.push({ numero: "", tipoClassificacao: 'C' });
    },
    removeTelefoneLinha(index) {
      this.formContato.telefones.splice(index, 1);
    },
    async salvarNovoContato() {
      if (this.salvandoNovoContato) return;
      if (!this.formContato.nome) { this.$toast.warning("Nome é obrigatório."); return; }
      if (!this.formContato.cpf || !this.cpfState(this.formContato.cpf)) { this.$toast.warning("CPF é obrigatório e deve ser válido."); return; }
      const emails = this.formContato.emails || [];
      if (!emails.length || emails.some(e => !e.valor || !this.emailState(e.valor))) { this.$toast.warning("Informe pelo menos um e-mail válido."); return; }
      const tels = this.formContato.telefones || [];
      if (!tels.length || tels.some(t => !t.numero || !this.telefoneState(t.numero))) { this.$toast.warning("Informe pelo menos um telefone válido."); return; }
      const payload = {
        CodCfo: this.$store.state.userDetails?.CodCfo,
        NomeContato: this.formContato.nome,
        DadosContatoCPF: this.formContato.cpf ? this.formContato.cpf.replace(/\D/g, '') : "",
        Preferencia: this.formContato.preferencia,
        Tipo: this.formContato.tipoVinculo,
        TipoComunicacao: this.formContato.tipoComunicacao,
        EmailsLista: this.formContato.emails.filter(e => e.valor).map(e => ({ Valor: String(e.valor).trim(), Relacao: e.relacao || "EC" })),
        TelefonesLista: this.formContato.telefones.filter(t => t.numero).map(t => ({
          Numero: t.numero.replace(/\D/g, ''),
          Relacao: this.relacaoTelefoneFromClassificacao(t.tipoClassificacao),
          TipoTelefone: this.tipoTelefoneFromClassificacao(t.tipoClassificacao)
        }))
      };
      this.salvandoNovoContato = true;
      try {
        await this.$http.post('/api/CdlBh/Contato', payload);
        this.$toast.success("Contato criado com sucesso!");
        this.$refs.modalContato.hide();
        this.fetchInitialData();
      } catch (e) {
        console.error(e);
        this.$toast.error("Erro ao criar contato.");
      } finally {
        this.salvandoNovoContato = false;
      }
    },

    async definirResponsavelLegal(idContato) {
      if (!idContato) return;
      const confirmou = await this.$bvModal.msgBoxConfirm(
        'Deseja definir este contato como Responsável Legal pela empresa? O contato anterior será removido desta função.',
        { title: 'Responsável Legal', size: 'sm', okVariant: 'primary', okTitle: 'Confirmar', centered: true }
      );
      if (!confirmou) return;
      try {
        await this.$http.put(`/api/CdlBh/Contato/${idContato}/ResponsavelLegal`);
        this.$toast.success('Responsável Legal atualizado com sucesso.');
        this.fetchInitialData();
      } catch (e) {
        this.$toast.error(e.response?.data?.Mensagem || 'Erro ao atualizar Responsável Legal.');
      }
    },

    async inativarContato(idContato) {
      if (!idContato) return;
      const confirmou = await this.$bvModal.msgBoxConfirm('Deseja inativar este contato? Esta ação não pode ser desfeita pelo portal.', {
        title: 'Inativar Contato', size: 'sm', okVariant: 'danger', okTitle: 'Inativar', centered: true
      });
      if (!confirmou) return;
      try {
        await this.$http.delete(`/api/CdlBh/Contato/${idContato}`);
        this.$toast.success('Contato inativado com sucesso.');
        this.fetchInitialData();
      } catch (e) {
        this.$toast.error(e.response?.data?.Mensagem || 'Erro ao inativar contato.');
      }
    },

    async limparEndereco(tipo) {
      const label = tipo === 'empresa' ? 'da Empresa' : 'de Cobrança';
      const confirmou = await this.$bvModal.msgBoxConfirm(`Deseja apagar o Endereço ${label}? Os campos serão limpos no cadastro.`, {
        title: 'Apagar Endereço', size: 'sm', okVariant: 'danger', okTitle: 'Apagar', centered: true
      });
      if (!confirmou) return;
      try {
        await this.$http.delete(`/api/CdlBh/Endereco/${tipo}`);
        this.$toast.success('Endereço removido com sucesso.');
        await this.fetchInitialData();
      } catch (e) {
        this.$toast.error('Erro ao remover endereço.');
      }
    },

    async salvarContatoDireto(contato) {
      if (!contato.nome) { this.$bvToast.toast('Nome é obrigatório', { variant: 'warning' }); return; }
      if (String(contato.cpf || '').trim() && !validateCPF(clearStr(String(contato.cpf || '')))) {
        this.$bvToast.toast('CPF inválido.', { variant: 'warning' });
        return;
      }
      if (!(contato.emails || []).every((email) => !email.valor || validateEmail(String(email.valor).trim()))) {
        this.$bvToast.toast('Informe e-mails válidos.', { variant: 'warning' });
        return;
      }
      if (!(contato.telefones || []).every((telefone) => !telefone.numero || /^\d+$/.test(String(telefone.numero).trim()))) {
        this.$bvToast.toast('Informe telefones válidos apenas com números.', { variant: 'warning' });
        return;
      }
      const esteTemBoleto = (contato.tipoComunicacao || []).includes('B');
      const outroTemBoleto = this.listaContatosUnificada.some(
        (c) => c.dados !== contato && (c.dados.tipoComunicacao || []).includes('B')
      );
      if (!esteTemBoleto && !outroTemBoleto) {
        this.$bvToast.toast(
          'É obrigatório que pelo menos um contato esteja marcado para receber boletos.',
          { variant: 'warning', title: 'Atenção', solid: true }
        );
        return;
      }
      this.$set(contato, 'carregando', true);
      const payload = {
        CodCfo: contato.CodCfo || this.$store.state.userDetails?.CodCfo,
        IdContato: contato.ID ? String(contato.ID) : null,
        NomeContato: contato.nome,
        DadosContatoCPF: contato.cpf ? contato.cpf.replace(/\D/g, '') : "",
        Preferencia: contato.preferencia,
        Tipo: contato.tipo,
        TipoComunicacao: contato.tipoComunicacao,
        EmailsLista: contato.emails.map(e => ({ Id: e.id ? String(e.id) : null, Valor: String(e.valor).trim(), Relacao: e.relacao || "EC" })),
        TelefonesLista: contato.telefones.map(t => ({
          Numero: t.numero ? t.numero.replace(/\D/g, '') : "",
          Relacao: this.relacaoTelefoneFromClassificacao(t.tipoClassificacao),
          TipoTelefone: this.tipoTelefoneFromClassificacao(t.tipoClassificacao)
        }))
      };
      try {
        const url = contato.ID ? `/api/CdlBh/Contato/${contato.ID}` : `/api/CdlBh/Contato`;
        console.log('[DEBUG salvarContatoDireto] EmailsLista:', JSON.stringify(payload.EmailsLista));
        if (contato.ID) await this.$http.put(url, payload);
        else await this.$http.post(url, payload);
        this.$bvToast.toast('Contato salvo com sucesso!', { variant: 'success', solid: true });
        this.fetchInitialData();
        if (this.$refs.modalContato && this.$refs.modalContato.isShow) this.$refs.modalContato.hide();
      } catch (error) {
        console.error("Erro ao salvar:", error);
        this.$bvToast.toast('Erro ao processar solicitação.', { variant: 'danger' });
      } finally {
        this.$set(contato, 'carregando', false);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
/* Layout */
.perfil-wrapper {
  padding: 24px 16px 48px;
  max-width: 1000px;
  margin: 0 auto;
}
.perfil-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
}

/* Hero */
.hero-card {
  background: linear-gradient(135deg, #05428E 0%, #16B3D3 100%);
  border-radius: 16px;
  padding: 28px 32px;
  display: flex;
  align-items: center;
  color: white;
  box-shadow: 0 8px 24px rgba(13, 47, 110, 0.22);
}
.hero-avatar {
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.18);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.7rem;
  margin-right: 20px;
  flex-shrink: 0;
}
.hero-info { flex: 1; min-width: 0; }
.hero-name {
  font-size: 1.4rem;
  font-weight: 700;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.meta-badge {
  display: inline-flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  padding: 3px 12px;
  font-size: 0.8rem;
  font-weight: 600;
}
.meta-badge--light { background: rgba(255, 255, 255, 0.1); }

.tipo-vinculo-toggle {
  display: flex;
  gap: 8px;
}

::v-deep .tipo-vinculo-toggle .btn {
  border-radius: 999px !important;
  font-weight: 700;
  padding: 0.5rem 1rem;
  min-width: 150px;
  box-shadow: 0 4px 12px rgba(5, 66, 142, 0.08);
}

::v-deep .tipo-vinculo-toggle .btn:not(.active) {
  background: #fff !important;
  color: #05428E !important;
}

::v-deep .tipo-vinculo-toggle .btn.active {
  background: linear-gradient(135deg, #05428E 0%, #16B3D3 100%) !important;
  border-color: #16B3D3 !important;
  color: #fff !important;
}

/* Validação — especificidade .inp.is-valid > .inp para ganhar o !important */

/* Tabs override */
::v-deep .nav-pills .nav-link {
  border-radius: 10px;
  color: #64748b;
  font-weight: 600;
  font-size: 0.875rem;
  padding: 9px 20px;
  transition: all 0.2s;
}
::v-deep .nav-pills .nav-link.active {
  background: linear-gradient(135deg, #05428E 0%, #16B3D3 100%);
  color: white;
  box-shadow: 0 4px 14px rgba(5, 66, 142, 0.32);
}
::v-deep .nav-pills .nav-link:not(.active):hover {
  background: #f1f5f9;
  color: #1e293b;
}

/* Panel */
.panel {
  background: #ffffff;
  border-radius: 16px;
  padding: 24px;
  border: 1px solid #e8edf5;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04), 0 6px 20px rgba(0, 0, 0, 0.04);
}
.panel__header {
  padding-bottom: 14px;
  border-bottom: 1px solid #f1f5f9;
}
.panel__title {
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.7px;
  color: #64748b;
}
.panel--success {
  border-color: #00BD80;
  border-left: 4px solid #00BD80;
  background: rgba(0, 189, 128, 0.04);
  .panel__header {
    border-bottom-color: rgba(0, 189, 128, 0.2);
    color: #00BD80;
  }
  .panel__title { color: #00965f; }
  .fa-check-circle { color: #00BD80; }
}

/* Fields */
.lbl {
  display: block;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #64748b;
  margin-bottom: 6px;
}
.inp {
  height: 40px !important;
  padding: 0 14px !important;
  border-radius: 10px !important;
  border: 1.5px solid #e2e8f0 !important;
  font-size: 0.875rem !important;
  background: #ffffff !important;
  color: #0f172a !important;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04) !important;
  transition: border-color 0.2s, box-shadow 0.2s;
  &:hover:not(:focus) { border-color: #cbd5e1 !important; }
  &:focus {
    border-color: #05428E !important;
    box-shadow: 0 0 0 4px rgba(5, 66, 142, 0.12) !important;
    outline: none !important;
  }
  &.is-valid {
    border-color: #00BD80 !important;
    background: rgba(0, 189, 128, 0.03) !important;
    background-image: none !important;
    padding-right: 14px !important;
    &:focus { box-shadow: 0 0 0 4px rgba(0, 189, 128, 0.12) !important; }
  }
  &.inp--obrig-invalido,
  &.is-invalid {
    border-color: #D42859 !important;
    background: rgba(212, 40, 89, 0.03) !important;
    background-image: none !important;
    padding-right: 14px !important;
    &:focus { box-shadow: 0 0 0 4px rgba(212, 40, 89, 0.12) !important; }
  }
}
.rm-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1.5px solid #fca5a5;
  background: #fff5f5;
  color: #D42859;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  transition: all 0.18s;
  flex-shrink: 0;
  user-select: none;
  &:hover, &:focus { background: #D42859; border-color: #D42859; color: #fff; outline: none; }
}
.inp--ro {
  background: #f8fafc !important;
  color: #64748b !important;
  cursor: default;
  border-color: #e8edf5 !important;
  box-shadow: none !important;
}

/* Upload */
.upload-box {
  background: #fffbf0;
  border: 1px solid #ffe082;
  border-left: 4px solid #ffc107;
  border-radius: 10px;
  padding: 18px 20px;
}
.upload-box__head {
  display: flex;
  align-items: flex-start;
}
.doc-rm-btn {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: none;
  background: #D42859;
  color: #fff;
  font-size: 16px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
  &:hover { background: #a81e46; }
}

/* Chamados */
.req-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px solid #f4f4f4;
  &:last-child { border-bottom: none; }
}
.req-tag {
  background: #e8f0fe;
  color: #05428E;
  border-radius: 20px;
  padding: 3px 12px;
  font-size: 0.75rem;
  font-weight: 700;
}

/* Contact card */
.contato-card {
  background: #ffffff;
  border: 1.5px solid #e8edf5;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04), 0 4px 12px rgba(0,0,0,0.04);
  transition: box-shadow 0.25s, border-color 0.25s, transform 0.2s;
  &:hover { box-shadow: 0 4px 20px rgba(5, 66, 142, 0.12); border-color: #93E3E3; transform: translateY(-1px); }
}
.contato-card__head {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  cursor: pointer;
  user-select: none;
  transition: background 0.15s;
  &:hover { background: #f8faff; }
  &:active { background: #eff6ff; }
}
.contato-card__body {
  padding: 24px 24px 28px;
  border-top: 1px solid #f1f5f9;
  background: #fafcff;
}
.ct-avatar {
  width: 42px;
  height: 42px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  font-weight: 700;
  color: white;
  flex-shrink: 0;
}
.ct-avatar--blue { background: linear-gradient(135deg, #05428E, #16B3D3); }
.ct-avatar--teal { background: linear-gradient(135deg, #17a2b8, #0e7a89); }
.ct-info { margin-left: 14px; flex: 1; min-width: 0; }
.ct-name { font-weight: 700; color: #212529; font-size: 0.95rem; }
.ct-sub { font-size: 0.8rem; color: #8898aa; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.ct-chevron { color: #adb5bd; font-size: 0.8rem; transition: transform 0.28s cubic-bezier(.4,0,.2,1); }
.ct-chevron--open { transform: rotate(180deg); }
/* Empty state */
.empty-state {
  text-align: center;
  padding: 56px 24px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.empty-state__icon-wrap {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: #f0f4ff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
  font-size: 1.8rem;
  color: #16B3D3;
}

/* Modal */
.mbox {
  background: #f8fafc;
  border-radius: 14px;
  padding: 18px 20px;
  border: 1px solid #e8edf5;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}
.mbox__title {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.7px;
  color: #64748b;
  padding-bottom: 10px;
  border-bottom: 1px solid #e8edf5;
  margin-bottom: 2px;
}
.mbox .inp {
  background: #ffffff !important;
  border-color: #e2e8f0 !important;
  box-shadow: 0 1px 2px rgba(0,0,0,0.04) !important;
  &:hover:not(:focus) { border-color: #cbd5e1 !important; }
  &:focus { border-color: #05428E !important; box-shadow: 0 0 0 4px rgba(5, 66, 142, 0.12) !important; }
  &.is-invalid { border-color: #D42859 !important; background: rgba(212, 40, 89, 0.03) !important; }
  &.is-valid   { border-color: #00BD80 !important; background: rgba(0, 189, 128, 0.03) !important; }
}

/* Tipo-card (seleção de tipo no modal novo contato) */
.tipo-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 28px 20px 22px;
  border: 2px solid #e2e8f0;
  border-radius: 14px;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.18s, box-shadow 0.18s, transform 0.15s;
  &:hover {
    border-color: #16B3D3;
    box-shadow: 0 6px 20px rgba(74, 144, 217, 0.15);
    transform: translateY(-2px);
  }
}
.tipo-card__icon-wrap {
  width: 60px;
  height: 60px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 14px;
  .material-icons { font-size: 28px; }
  &--blue { background: rgba(22, 179, 211, 0.14); color: #05428E; }
  &--green { background: rgba(40, 167, 69, 0.12); color: #276749; }
}
.tipo-card__label {
  font-size: 1rem;
  color: #1a202c;
  margin-bottom: 8px;
  display: block;
}
.tipo-card__desc {
  font-size: 0.82rem;
  color: #718096;
  margin-bottom: 16px;
  line-height: 1.5;
}
.tipo-card__action {
  font-size: 0.8rem;
  font-weight: 600;
  color: #16B3D3;
  margin-top: auto;
}
.tipo-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  &--blue { background: rgba(22, 179, 211, 0.14); color: #05428E; }
  &--green { background: rgba(40, 167, 69, 0.12); color: #276749; }
}

/* Transition */
.slide-fade-enter-active { transition: all 0.25s ease; }
.slide-fade-leave-active { transition: all 0.18s ease; }
.slide-fade-enter, .slide-fade-leave-to { transform: translateY(-6px); opacity: 0; }
</style>
